import { useSyncExternalStore } from 'react';

let activeFullscreenLoaders = 0;
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => activeFullscreenLoaders > 0;

export const registerFullscreenLoader = () => {
  activeFullscreenLoaders += 1;
  notify();

  return () => {
    activeFullscreenLoaders = Math.max(0, activeFullscreenLoaders - 1);
    notify();
  };
};

export const useIsFullscreenLoaderVisible = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
